import { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import { Banner, Cell, List, Spinner } from "@telegram-apps/telegram-ui";
import { api } from "../../lib/api.js";

// Wrapper for every /superadmin/* route. Verifies the caller is still a
// superadmin (the server enforces this independently — this is just for UX
// so a demoted user sees an immediate "forbidden" instead of a string of
// 403s) and renders desktop-friendly chrome (header + pill tabs).
const TABS = [
  { to: "/superadmin",            label: "Главная",     end: true },
  { to: "/superadmin/users",      label: "Пилоты" },
  { to: "/superadmin/airfields",  label: "Аэродромы" },
  { to: "/superadmin/audit",      label: "Аудит" },
  { to: "/superadmin/warnings",   label: "Предупр." },
  { to: "/superadmin/documents",  label: "Документы" },
  { to: "/superadmin/messages",   label: "Сообщения" },
];

export default function SuperadminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [me, setMe] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api("/api/v1/me")
      .then((r) => {
        if (!r?.user?.is_superadmin) setError("Доступ только для суперадмина.");
        else setMe(r);
      })
      .catch((e) => setError(e.message));
  }, []);

  if (error) {
    return (
      <div className="portal-shell">
        <List>
          <Banner type="section" header="Доступ запрещён" description={error}>
            <Cell onClick={() => navigate("/")}>← На главную</Cell>
          </Banner>
        </List>
      </div>
    );
  }
  if (!me) {
    return (
      <div className="portal-shell" style={{ display: "flex", justifyContent: "center", padding: 48 }}>
        <Spinner size="l" />
      </div>
    );
  }

  return (
    <div className="portal-shell">
      <div className="portal-header">
        <div className="portal-header__title">
          <span className="portal-header__eyebrow">Суперадмин-портал</span>
          <h1 className="portal-header__h1">RCFlyers</h1>
        </div>
        <button type="button" className="portal-back" onClick={() => navigate("/")}>
          <span aria-hidden="true">←</span>
          На главную
        </button>
      </div>

      <nav className="portal-tabs" aria-label="Разделы суперадмина">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              isActive ? "portal-tab portal-tab--active" : "portal-tab"
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>

      <div className="portal-content">
        <Outlet context={{ me, location }} />
      </div>
    </div>
  );
}
